import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './design.css';
import Nav from './nav';
import Footer from './footer';
import Top from './top';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Design = () => {
  const { cid } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubproduct = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/fetch-subproduct/${cid}`);

        if (response.data) {
          setProducts(response.data.subproducts || []);
          setCategoryName(response.data.category?.cname || '');
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error('Error fetching subproducts:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSubproduct();
  }, [cid]);

  if (loading) {
    return (
      <>
        <Nav />
        <div className="container text-center my-5">
          <h4>Loading products...</h4>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Nav />
      <Top />

      <div className="container">
        <ul className="filter_ul">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>&nbsp;/&nbsp;</li>
          <li>{categoryName || 'Product'}</li>
        </ul>
      </div>

      <div className="container design-container">
        <div className="row">
          {products.length ? (
            products.map((item) => (
              <div key={item.did} className="col-sm-3 design_div">
                <Link to={`/product-preview/${item.did}`}>
                  <img
                    src={`${baseURL}/images/${item.image}`}
                    alt={item.dname}
                    className="design_image"
                    loading="lazy"
                  />
                  <p className="design_name"><b>{item.dname}</b></p>
                </Link>
                <p className="design_ds">{item.ds1}</p>
              </div>
            ))
          ) : (
            <div className="col-12 text-center my-5">
              <h5>No designs found for this category.</h5>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Design;
